const Modal = require('app/ui/Modal');
const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');
const GraphQLMutation = require('app/graphql/Mutation');

class ShowModal {

    defaultOptions() {
        return {
            'id': window.uniqid(),
            'title': window.translate('app.restaurant.show.tabs.analyse.synthesis.title'),
            'restaurant': null,
            'onClose': function(event){},
            'onShown': function(event){},
            'onNewRestofutePrice': function(){}
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.restaurant = this.settings.restaurant;
        if(!this.restaurant.id){
            window.notify("Missing restaurant object in SynthesisShowModal","danger");
        }

        this.initialize();
    }

    initialize() {
        var self = this;

        this.build();
    }

    build(){

        this.$content = $('<div/>')
        .addClass('restaurant-analyse-synthesis-modal');

        this.modal = new Modal({
            'id': this.settings.id,
            'title': this.settings.title,
            'showFooter': false,
            'content' : this.$content,
            'modalSize': "full",

            'onShown':this.settings.onShown,
            'onClose':this.settings.onClose,
        })

        this.loadData();

        this.modal.show();
    }

    refresh(){
        this.loadData();
    }


    loadData(){
        var self = this;

        this.$content
        .html('')
        .append(window.App.generateLoader());

        let queries = [
            this.buildRestaurantSellerQuery(),
            this.buildProductQuery(),
            this.buildProductPriceQuery(),
        ];

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.buildTable(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    buildRestaurantSellerQuery(){
        var self = this;

        let parameters = {
            'id': this.restaurant.id
        };

        let fields = [
            'seller { id commission }',
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'restaurant',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': false,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }

    buildProductQuery(){
        var self = this;

        let parameters = {
            'orderBy': 'productName',
            'dir': 'ASC',
            'first': 100000,
            'filter': {
                'restaurant': this.restaurant.id,
                'trimester': 0
            }
        };

        let fields = [
            'trimester',
            'product { id reference price quantity supplierPrice unit }',
            'total',
            'quantity',
            'unit',
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'analysisRestaurantProducts',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': true,
        });

        return query;
    }

    buildProductPriceQuery(){
        var self = this;

        let parameters = {
            'first': 100000,
            'filter': {
                'restaurant': this.restaurant.id,
            }
        };

        let fields = [
            'product { id  }',
            'price'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'analysisRestaurantProductPrices',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': true,
        });

        return query;
    }


    getRestofutePrice(productAnalyse){
        let productId = productAnalyse.product.id;
        for(var i in this.productPrices ){
            let productPrice = this.productPrices[i].node;
            if(productPrice.product.id == productId){
                return productPrice.price;
            }
        }
        return productAnalyse.product.price;
    }

    buildTable(data){
        var self = this;

        this.$content.html('');
        this.productAnalyses = data.analysisRestaurantProducts.edges;
        this.productPrices = data.analysisRestaurantProductPrices.edges;
        this.seller = data.restaurant.seller;

        this.$table = $('<table/>')
        .addClass('table table-striped')
        .append(
            $('<thead/>')
            .append(
                $('<tr/>')
                .append(
                    $('<th/>')
                    .append(window.translate('app.restaurant.show.tabs.analyse.synthesis.product.label'))
                )
                .append(
                    $('<th/>')
                    .append(window.translate('app.restaurant.show.tabs.analyse.synthesis.quantity.label'))
                )
                .append(
                    $('<th/>')
                    .append(window.translate('app.restaurant.show.tabs.analyse.synthesis.total.label'))
                )
                .append(
                    $('<th/>')
                    .append(window.translate('app.restaurant.show.tabs.analyse.synthesis.averagePrice.label'))
                )
                .append(
                    $('<th/>')
                    .append(window.translate('app.restaurant.show.tabs.analyse.synthesis.restofutePrice.label'))
                )
                .append(
                    $('<th/>')
                    .append(window.translate('app.restaurant.show.tabs.analyse.synthesis.gap.label'))
                )
                .append(
                    $('<th/>')
                    .append(window.translate('app.restaurant.show.tabs.analyse.synthesis.savings.label'))
                )
                .append(
                    $('<th/>')
                    .append(window.translate('app.restaurant.show.tabs.analyse.synthesis.supplierPrice.label'))
                )
                .append(
                    $('<th/>')
                    .append(window.translate('app.restaurant.show.tabs.analyse.synthesis.margin.label'))
                )
            )
        );

        this.$tbody = $('<tbody/>')
        .appendTo(this.$table);

        let totalProduct = 0;
        let totalSupplier = 0;
        let totalSavings = 0;
        let totalMargin = 0;

        for(var i in this.productAnalyses){
            let edge = this.productAnalyses[i];
            let productAnalyse = edge.node;

            let productId = productAnalyse.product.id;
            let productPrice = this.getRestofutePrice(productAnalyse);

            let $productName = $("<div/>")
            .append(productAnalyse.product.reference);

            let $quantity = $("<div/>")
            .addClass('synthesis-line-quantity')
            .attr('data-value',productAnalyse.quantity)
            .append(productAnalyse.quantity);

            let $total = $("<div/>")
            .addClass('synthesis-line-total')
            .attr('data-value',productAnalyse.total)
            .append(window.formatFloat(productAnalyse.total) + '&euro;');

            let averagePrice = productAnalyse.total / productAnalyse.quantity;
            let unit = productAnalyse.unit;
            let $averagePrice = $("<div/>")
            .append(window.formatFloat(averagePrice) + '&euro; / ' + unit);

            let $restofutePrice = $("<div/>")
            .addClass('synthesis-restofute-price-container')
            .attr('data-product',productId)
            .attr('data-default-price',productPrice)
            .attr('data-price',productPrice)
            .append(
                $('<span/>')
                .addClass('synthesis-restofute-price-input')
                .append(
                    window.formatFloat(productPrice) 
                )
            )
            .append(' &euro; / ' + productAnalyse.product.unit)
            .on('dblclick',function(event){
                self.onDblClickRestofutePrice($(this));
            });

            let gap = - (productPrice - averagePrice);
            let $gap = $("<div/>")
            .addClass('synthesis-line-gap')
            .append(
                $('<span/>')
                .addClass('value')
                .append(window.formatFloat(gap) + '&euro;')
            )
            .append(' / '+ productAnalyse.product.unit);
            if(gap < 0 ){
                $gap.addClass('text-danger');
            }


            let restofuteTotalPrice = productAnalyse.quantity * productPrice;
            let savings = productAnalyse.total - restofuteTotalPrice;
            let savingsPercent = (restofuteTotalPrice / productAnalyse.total) * 100;
            let $savings = $("<div/>")
            .addClass('synthesis-line-savings')
            .append(
                $('<span/>')
                .addClass('value')
                .append(window.formatFloat(savings) + '&euro;')
            )
            .append(' ')
            .append(
                $('<span/>')
                .addClass('percent')
                .append('('+window.formatFloat(savingsPercent)+'%)')
            );
            if(savings < 0){
                $savings.addClass('text-danger')
            }

            let $supplierPrice = $("<div/>")
            .append(window.formatFloat(productAnalyse.product.supplierPrice) + '&euro;');


            let supplierTotalPrice = productAnalyse.quantity * productAnalyse.product.supplierPrice;
            let margin = restofuteTotalPrice - supplierTotalPrice;
            let marginPercent = (margin / supplierTotalPrice) * 100;
            let $margin = $("<div/>")
            .addClass('synthesis-line-margin')
            .data('supplier-total-price',supplierTotalPrice)
            .append(
                $('<span/>')
                .addClass('value')
                .append(window.formatFloat(margin) + '&euro;')
            )
            .append(' ')
            .append(
                $('<span/>')
                .addClass('percent')
                .append('('+window.formatFloat(marginPercent)+'%)')
            )

            if(gap > 0){
                totalProduct += parseFloat(productAnalyse.total);
                totalSavings += parseFloat(savings);
            }
            totalSupplier += supplierTotalPrice;
            totalMargin += margin;

            let $row = $('<tr/>')
            .addClass('product-analyse-line')
            .data('savings',savings)
            .data('margin',margin)
            .data('price',productPrice)
            .data('quantity',productAnalyse.quantity)
            .data('supplier-total-price',supplierTotalPrice)
            .append(
                $('<td/>')
                .append($productName)
            )
            .append(
                $('<td/>')
                .append($quantity)
            )
            .append(
                $('<td/>')
                .append($total)
            )
            .append(
                $('<td/>')
                .append($averagePrice)
            )
            .append(
                $('<td/>')
                .append($restofutePrice)
            )
            .append(
                $('<td/>')
                .append($gap)
            )
            .append(
                $('<td/>')
                .append($savings)
            )
            .append(
                $('<td/>')
                .append($supplierPrice)
            )
            .append(
                $('<td/>')
                .append($margin)
            );

            this.$tbody.append($row);
        }


        let totalSavingsPercent = (totalSavings / totalProduct) * 100;
        let totalMarginPercent = (totalMargin / totalSupplier) * 100;
        let sellerRemuneration = totalMargin * (this.seller.commission / 100);
        let finalNetMargin = totalMargin * 0.7;
        let finalNetMarginPercent = (totalMargin * ((1-(this.seller.commission/100)) / totalSupplier)) * 100;
        this.$synthesis = $('<ul/>')
        .addClass('list-unstyled')
        .append(
            $('<li/>')
            .addClass('synthesis-total-savings')
            .append(window.translate('app.restaurant.show.tabs.analyse.synthesis.totalSavings'))
            .append(' : ')
            .append(
                $('<span/>')
                .addClass('value')
                .append(window.formatFloat(totalSavings)+ " &euro;")
            )
            .append(' ')
            .append(
                $('<span/>')
                .addClass('percent')
                .append('('+window.formatFloat(totalSavingsPercent)+ " %)")
            )
        )
        .append(
            $('<li/>')
            .append(window.translate('app.restaurant.show.tabs.analyse.synthesis.totalMargin'))
            .append(' : ')
            .append(window.formatFloat(totalMargin)+ " &euro;")
            .append(' ')
            .append('('+window.formatFloat(totalMarginPercent)+ " %)")
        )
        .append(
            $('<li/>')
            .addClass('synthesis-seller-remuneration')
            .append(window.translate('app.restaurant.show.tabs.analyse.synthesis.sellerRemuneration'))
            .append(' : ')
            .append(
                $('<span/>')
                .addClass('value')
                .append(window.formatFloat(sellerRemuneration)+ " &euro;")
            )
        )
        .append(
            $('<li/>')
            .addClass('synthesis-final-net-margin')
            .append(window.translate('app.restaurant.show.tabs.analyse.synthesis.finalNetMargin'))
            .append(' : ')
            .append(
                $('<span/>')
                .addClass('value')
                .append(window.formatFloat(finalNetMargin)+ " &euro;")
            )
            .append(' ')
            .append(
                $('<span/>')
                .addClass('percent')
                .append('('+window.formatFloat(finalNetMarginPercent)+ " %)")
            )
        )

        this.$content
        .append(this.$table)
        .append(this.$synthesis);
    }

    onDblClickRestofutePrice($item){
        var self = this;

        let productId = $item.data('product');
        let price = $item.data('price');

        let $input = $('<input/>')
        .attr('name','restofutePriceByProduct['+productId+']')
        .val(price);

        let onSuccess = function(){
            let newPrice = $input.val();
            $item.data('price',newPrice);
            $item.attr('data-price',newPrice);
            
            $('.synthesis-restofute-price-input',$item)
            .html('')
            .append(
                window.formatFloat(newPrice) 
            )

            let $line = $item.closest('.product-analyse-line');

            let $total = $('.synthesis-line-total',$line);
            let $quantity = $('.synthesis-line-quantity',$line);
            let $saving = $('.synthesis-line-savings',$line);
            let $gap = $('.synthesis-line-gap',$line);
            let $margin = $('.synthesis-line-margin',$line);

            let total = parseFloat($total.data('value'));
            let quantity = parseFloat($quantity.data('value'));

            let newSaving = total - (newPrice * quantity);
            let newSavingPercent = (newPrice * quantity / total) * 100;

            let newGap = - (newPrice - (total / quantity));

            let totalSupplierPrice = $margin.data('supplier-total-price');
            let newMargin = (newPrice * quantity) - totalSupplierPrice;
            let newMarginPercent = (newPrice * quantity / totalSupplierPrice) * 100;

            $('.value',$saving).empty().html(window.formatFloat(newSaving) + '&euro;');
            $('.percent',$saving).empty().html('('+window.formatFloat(newSavingPercent)+'%)');
            if(newSaving < 0){
                $saving.addClass('text-danger');
            }else{
                $saving.removeClass('text-danger');
            }

            $('.value',$gap).empty().html(window.formatFloat(newGap) + '&euro;');
            if(newGap < 0){
                $gap.addClass('text-danger');
            }else{
                $gap.removeClass('text-danger');
            }

            $('.value',$margin).empty().html(window.formatFloat(newMargin) + '&euro;');
            $('.percent',$margin).empty().html('('+window.formatFloat(newMarginPercent)+'%)');

            $line
            .data('savings',newSaving)
            .data('margin',newMargin)
            .data('price',newPrice);
            

            self.refreshTotalSynthesis();
        };
        

        $input.on('change',function(){
            self.sendRestofutePrice(productId,$input.val(),onSuccess);
        });

        $('.synthesis-restofute-price-input',$item)
        .html('')
        .append($input);
    }

    refreshTotalSynthesis(){

        let $lines = $('.product-analyse-line',this.$tbody);

        let totalSavings = 0;
        let totalProduct = 0;
        let totalSupplier = 0;
        let totalMargin = 0;
        let finalNetMargin = 0;
        let totalSavingsPercent = 0;
        let totalMarginPercent = 0;
        let finalNetMarginPercent = 0;
        let sellerRemuneration = 0;

        $lines.each(function(){
            let $line = $(this);

            let savings = $line.data('savings');
            let margin = $line.data('margin');
            let supplierTotal = $line.data('supplier-total-price');
            let price = $line.data('price');
            let quantity = $line.data('quantity');

            let total = price * quantity;

            totalSavings += parseFloat(savings);
            totalProduct += parseFloat(total);
            totalSupplier += parseFloat(supplierTotal);
            totalMargin += parseFloat(margin);


        });

        totalSavingsPercent = (totalSavings / totalProduct) * 100;
        totalMarginPercent = (totalMargin / totalSupplier) * 100;
        sellerRemuneration = totalMargin * (this.seller.commission / 100);
        finalNetMargin = totalMargin * 0.7;
        finalNetMarginPercent = (totalMargin * ((1-(this.seller.commission/100)) / totalSupplier)) * 100;

        let $synthesisTotalSavings = $('.synthesis-total-savings',this.$synthesis);
        let $synthesisTotalMargin = $('.synthesis-total-margin',this.$synthesis);
        let $synthesisSellerRemuneration = $('.synthesis-seller-remuneration',this.$synthesis);
        let $synthesisFinalNetMargin = $('.synthesis-final-net-margin',this.$synthesis);

        $('.value',$synthesisTotalSavings).empty().html(window.formatFloat(totalSavings)+ " &euro;");
        $('.percent',$synthesisTotalSavings).empty().html('('+window.formatFloat(totalSavingsPercent)+ " %)");

        $('.value',$synthesisTotalMargin).empty().html(window.formatFloat(totalMargin)+ " &euro;");
        $('.percent',$synthesisTotalMargin).empty().html('('+window.formatFloat(totalMarginPercent)+ " %)");

        $('.value',$synthesisSellerRemuneration).empty().html(window.formatFloat(sellerRemuneration)+ " &euro;");

        $('.value',$synthesisFinalNetMargin).empty().html(window.formatFloat(finalNetMargin)+ " &euro;");
        $('.percent',$synthesisFinalNetMargin).empty().html('('+window.formatFloat(finalNetMarginPercent)+ " %)");

    }

    sendRestofutePrice(productId, price,onSuccessCallback){
        var self = this;

        let $btn = this.$btnGenerate;


        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'restaurant': {
                'value': this.restaurant.id,
                'type': 'Int!'
            },
            'product': {
                'value': productId,
                'type': 'Int!'
            },
            'price': {
                'value': price,
                'type': "String!"
            }
        };
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "SubmitAnalysisRestaurantProductPrice",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                if(data.success){
                    window.notify(data.message,'success');
                    onSuccessCallback();
                    self.settings.onNewRestofutePrice();
                }else{
                    window.notify(data.message,'error');
                }
            },
            'error': function(message, xhr){
                window.notify(message,'error');
            },
            'after': function(){
                // do not refresh now, see issue #16 for more informations
                //self.refresh();
            }
        });
        mutation.execute();

    }
}

module.exports = ShowModal;

